import React from 'react'
import { useDiagnostics } from './DiagnosticsContext'
import DiagnosticsPanel from './DiagnosticsPanel.js'

export default function TroubleShootingPage() {
  const { badDataBin } = useDiagnostics()

  const exportCSV = () => {
    if (!badDataBin.length) return
    const header = Object.keys(badDataBin[0])
    const rows = [
      header.join(','),
      ...badDataBin.map(row => header.map(k => JSON.stringify(row[k] ?? '')).join(','))
    ]
    const blob = new Blob([rows.join('\n')], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = 'diagnostics_export.csv'
    link.click()
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Troubleshooting</h2>
      <DiagnosticsPanel
        flaggedRows={badDataBin}
        issues={badDataBin.map(d => ({
          reason: d.reasons,
          time: d._time || d.sample_time
        }))}
        onExport={exportCSV}
      />
    </div>
  )
}
